export const APP_CONFIG_VALUE: any = {
  AFTER_LOGIN_REDIRECT_URL: '',
  AFTER_LOGOUT_REDIRECT_URL: '',
};
